<template>
  <div>
    <div id="filterHeader">
      <div id="hideButton" @click="toggleShow">
          <img id="arrowDown" v-if="show" src="../assets/down-arrow.svg" />
          <img id="arrowUp" v-else src="../assets/up-arrow.svg" />
      </div>
      <div style="marginRight: auto;">{{filterGroup.groupName}}</div>
    </div>
    <div id="filterList" v-if="show">
      <div v-for="option in filterGroup.options" :key="option" class="filter">
        <label class="checkbox">
          <input type="checkbox" :id="option" :name="option" class="checkbox"
            :checked="selectedFilters && selectedFilters.includes(option)"
            @input="toggleFilter(option)"
          />
          <span></span>
          <div id="optionText">{{option}}</div>
        </label>
      </div>
   </div>
  </div>
</template>

<style>
.expanded {
  border-bottom: 2px solid black;
}
</style>
<style scoped>
#filterHeader {
  border-left: 2px solid black;
  border-top: 2px solid black;
  height: 40px;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}
#filterList {
  padding-top: 10px;
  padding-bottom: 10px;
  border-left: 2px solid black;
}
.filter:first-of-type {
  margin-top: 0px;
}
.filter {
  font-size: 15px;
  font-weight: bold;
  margin-left: 20px;
  margin-right: 10px;
  margin-top: 10px;
  text-align: left;
}
#filterList .filter:last-of-type {
  padding-bottom: 10px;
}
label.checkbox input[type="checkbox"] {display:none;}
label.checkbox span {
  display:inline-block;
  border:2px solid black;
  border-radius:100%;
  width:17px;
  height:17px;
  background: white;
  vertical-align:middle;
  margin:3px;
  position: absolute;
  transition:width 0.1s, height 0.1s, margin 0.1s;
  cursor: pointer;
}
label.checkbox :checked + span {
  background: #ffd63a;
  width:19px;
  height:19px;
  margin: 2px;
}
label.checkbox :checked + span:after {
  font-size: 20px;
  position: absolute;
  top: -2px;
  left: 5px;
  color: black;
}
#optionText {
  padding-left:1.4em;
  margin-left: 1.4em;
  display:inline-block;
  margin-top: 0.22em;
}
#hideButton {
  margin-right: auto;
  font-size: 30px;
  height: 100%;
  width: 40px;
  cursor: pointer;
  border-right: 2px solid black;
}
#arrowUp {
  height: 17px;
}
#arrowDown {
  height: 15px;
}
</style>

<script>
export default {
  name: 'FilterBox',
  props: ['filterGroup', 'selectedFilters'],
  methods: {
    toggleFilter(option) {
      this.$emit('toggle-filter', option);
    },
    toggleShow(e) {
      this.$data.show = !this.$data.show;
      e.target.closest('#filterHeader').classList.toggle('expanded');
    },
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>
